import { render, staticRenderFns } from "./t-button.vue?vue&type=template&id=c6554f80&"
import script from "./t-button.vue?vue&type=script&lang=js&"
export * from "./t-button.vue?vue&type=script&lang=js&"
import style0 from "./t-button.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports